import { Grid } from '@mui/material';
import { Field } from 'formik';
import React from 'react';
import HdFormikPasswordField from '../../../../../form/formik/components/password-field/HdFormikPasswordField';
import HdFormControl from '../../../../../form/components/form-control/HdFormControl';

export default function Klaviyo({ isEditing }: { isEditing: boolean }) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='publicKey'
              required
              label='Public API Key'
              helperText='Specify your public API key.'
              masked={isEditing}
              component={HdFormikPasswordField}
            />
          </HdFormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='privateKey'
              required
              label='Private API Key'
              helperText='Specify your private API key.'
              masked={isEditing}
              component={HdFormikPasswordField}
            />
          </HdFormControl>
        </Grid>
      </Grid>
    </>
  );
}
